// Court scheduling logic

const THANKSGIVING_2026 = "2026-11-26";

const FEDERAL_HOLIDAYS_2026 = new Set([
  "2026-01-01",
  "2026-01-19",
  "2026-02-16",
  "2026-05-25",
  "2026-06-19",
  "2026-07-03",
  "2026-09-07",
  "2026-10-12",
  "2026-11-11",
  THANKSGIVING_2026,
  "2026-12-25",
]);

// ---------- Helpers ----------

function addDays(date, days) {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
}

function formatISO(date) {
  return date.toISOString().split("T")[0];
}

function firstTuesdayOfMonth(year, monthIndex) {
  const d = new Date(year, monthIndex, 1);
  const day = d.getDay(); // 0 = Sun, 2 = Tue
  const diff = (2 - day + 7) % 7;
  d.setDate(1 + diff);
  return d;
}

function nextThursdayOnOrAfter(date) {
  const d = new Date(date);
  const day = d.getDay();
  const diff = (4 - day + 7) % 7;
  d.setDate(d.getDate() + diff);
  return d;
}

function isFederalHoliday(date) {
  return FEDERAL_HOLIDAYS_2026.has(formatISO(date));
}

// ---------- Municipal Court ----------

function getNextMunicipalCourt({ requiresSummons }) {
  const today = new Date();

  // 🔥 KEY CHANGE HERE
  const daysOut = requiresSummons ? 28 : 70; // 4 weeks vs 10 weeks
  const target = addDays(today, daysOut);

  for (let i = 0; i < 18; i++) {
    const monthOffset = target.getMonth() + i;
    const year = target.getFullYear() + Math.floor(monthOffset / 12);
    const monthIndex = monthOffset % 12;

    let courtDate = firstTuesdayOfMonth(year, monthIndex);

    // must be AFTER target
    if (courtDate < target) continue;

    // skip holidays
    while (isFederalHoliday(courtDate)) {
      const nextMonth = courtDate.getMonth() + 1;
      const nextYear = courtDate.getFullYear() + Math.floor(nextMonth / 12);
      courtDate = firstTuesdayOfMonth(nextYear, nextMonth % 12);
    }

    return {
      court: "Saguache Municipal Court",
      date: formatISO(courtDate),
      time: "6:00p",
    };
  }

  return null;
}

// ---------- County / State ----------

function getNextCountyStateCourt({ requiresSummons }) {
  const today = new Date();

  const daysOut = requiresSummons ? 28 : 70;
  const target = addDays(today, daysOut);

  let courtDate = nextThursdayOnOrAfter(target);

  while (isFederalHoliday(courtDate)) {
    courtDate = addDays(courtDate, 7);
  }

  return {
    court: "Saguache County Court",
    date: formatISO(courtDate),
    time: "0830a",
  };
}

// ---------- Main export ----------

export function getCourtDates2026({ jurisdiction, requiresSummons }) {

  if (jurisdiction === "MUNI_SAGUACHE") {
    const court = getNextMunicipalCourt({ requiresSummons });
    return court ? [court] : [];
  }

  if (jurisdiction === "COUNTY_SAGUACHE") {
    return [getNextCountyStateCourt({ requiresSummons })];
  }

  if (jurisdiction === "STATE_CO") {
    const court = getNextCountyStateCourt({ requiresSummons });
    return [{ ...court, court: "Saguache County Court" }];
  }

  return [];
}